/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import DevorderUrl from './DevorderUrl';
import SupplierUrl from './SupplierUrl';
import SettingUrl from './SettingUrl';
import TodoListUrl from './TodoListUrl';
import PlaceholderUrl from './PlaceholderUrl';
import ComponentOrderUrl from './ComponentOrderUrl';
import LibraryTemplateURL from './LibraryTemplateURL';
import './SubHeader.css';

function VerticalMenu(props) {
  const location = useLocation();
  const { productDetails } = props;
  const { state, search } = location;
  const queryParams = new URLSearchParams(search);
  const querySupplierId = queryParams.get('supplierId');
  const [isGradingsPresent, setIsGradingsPresent] = useState(false);
  const hideSubheader = [
    '/supplier-suggestion',
    '/masters',
    '/documents',
    '/pim-v2',
    '/development-order-overview/create',
    '/development-order-overview/edit/',
  ];

  const history = useHistory();

  const pathName = history.location.pathname;
  useEffect(() => {
    if (productDetails?.gradingGroups?.length > 0) {
      setIsGradingsPresent(true);
    } else {
      setIsGradingsPresent(false);
    }
  }, [productDetails]);

  const renderUrlBasedComponent = () => {
    switch (true) {
      case pathName.includes('/component-order'):
        return <ComponentOrderUrl />;

      case pathName.includes('/placeholder-management'):
      case pathName.includes('/development-order-overview'):
      case pathName.includes('/modules-bulk-edit'):
        return <PlaceholderUrl />;

      case pathName.includes('/suppliers') || pathName.includes('/supplier/'):
        return <SupplierUrl state={{ ...state, supplierId: querySupplierId }} />;
      case pathName.includes('/settings/'):
        return <SettingUrl />;
      case [
        '/planning/planning-actual',
        '/planning/planning-bottomup',
        '/planning/planning-bottomup/channel-setting',
        '/submit-download-history',
        '/product-list',
        'operational-cp',
        'product-cp',
        'logs',
        '/rangeplan/card-view',
        '/rangeplan/add',
        '/rangeplan/edit',
        '/rangeplan/archived',
      ].some((item) => pathName.includes(item)):
        return <PlaceholderUrl />;
      case pathName.includes('/digital-assets-management'):
        return null;
      default:
        return <LibraryTemplateURL />;
    }
  };

  let content;
  if (hideSubheader.some((v) => pathName.indexOf(v) >= 0)) {
    content = '';
  } else if (pathName.includes('/development-order/')) {
    content = <DevorderUrl isGradingsPresent={isGradingsPresent} />;
  } else if (pathName.includes('/todo-list')) {
    content = <TodoListUrl pathName={pathName} imageWidth={72} />;
  } else {
    content = renderUrlBasedComponent();
  }
  return content;
}

export default VerticalMenu;
